import { IApplicationState } from '../../types/redux';

export function getNewbuildingInfo(state: IApplicationState) {
  return state.newbuildingInfo;
}
